import React, { useEffect} from "react";
import { Typography, Table, Collapse, Tooltip } from "antd";
import {InfoCircleOutlined} from "@ant-design/icons";
import ShiftsLevelFilter from "./filter";
import moment from "moment";
import Pageloader from "../../../../components/loader";
import * as actionPage from "../../../../redux/actions/dashboard.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { Title, Text } = Typography;
const { Panel } = Collapse;
const pageName = "Shift Level View";

const ShiftsLevel = (props) => {

  useEffect(() => {
    if (props?.pageFilter){
      postLists(props.pageFilter)
    }
  }, [props.pageFilter])

  const postLists = async(value) => {
    const {start_date, end_date} = value;
    if(start_date && end_date){
      const pageFilterData = {
        ...value,
        start_date: start_date.unix(),
        end_date: end_date.unix(),
        zoneIds: value?.zoneIds?.length === 0 ? undefined : await value?.zoneIds?.toString(),
        shiftLevelView: true,
      };
      const {date, ...rest} = pageFilterData
      rest?.zoneIds && await props.actionPage.ShiftLevelListAction(rest);
    }
  }

  const columns = [
    {
      title: 'Shift ID',
      dataIndex: 'shift_id',
      render: (value) => ( `${value}` || "-" ),
      sorter: {
        compare: (a, b) => a.shift_id - b.shift_id,
        multiple: 1,
      },
    },
    {
      title: 'Shift Start Date Time',
      dataIndex: 'start_time',
      render: (value) => {
        return value ?
        <><span>{moment(value).format("DD MMMM, yyyy")}</span>
        <p>{moment(value).format("h:mm A")}</p></>:"-"
      },
      sorter: {
        compare: (a, b) => a.start_time.localeCompare(b.start_time),
        multiple: 1,
      },   
    },
    {
      title: 'Shift End Date Time',
      dataIndex: 'end_time',
      render: (value) => {
        return value ?
        <><span>{moment(value).format("DD MMMM, yyyy")}</span>
        <p>{moment(value).format("h:mm A")}</p></>:"-"
      },
      sorter: {
        compare: (a, b) => a.end_time.localeCompare(b.end_time),
        multiple: 1,
      },   
    },
    {
      title: ()=> <div>
        Planned Slots &nbsp;
        <Tooltip
            title="Sum of slots made available through bulk upload, single shift created later is excluded"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'planned_slots',
      render: (value) => ( <Text>{value.toFixed(2)}</Text> || "-" ),
      sorter: {
        compare: (a, b) => a.planned_slots - b.planned_slots,
        multiple: 1,
      },
    },
    {
      title:  ()=> <div>
        Scheduled Slots &nbsp;
        <Tooltip
            title="Sum of slots picked by rider, including bulk and single shifts"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'scheduled_slots',
      render: (value) => ( <Text>{value.toFixed(2)}</Text> || "-" ),
      sorter: {
        compare: (a, b) => a.scheduled_slots - b.scheduled_slots,
        multiple: 1,
      },
    },
    {
      title:  ()=> <div>
        Overtime Shifts &nbsp;
        <Tooltip
            title="Sum of slots made available through single shift creation as extra shif"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'overtime_shifts',
      render: (value) => ( <Text>{value.toFixed(2)}</Text> || "-" ),
      sorter: {
        compare: (a, b) => a.overtime_shifts - b.overtime_shifts,
        multiple: 1,
      },
    },
    {
      title:  ()=> <div>
        Extra Shifts &nbsp;
        <Tooltip
            title="Sum of slots made available through single shift creation as extra shift"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'extra_shifts',
      render: (value) => ( <Text>{value.toFixed(2)}</Text> || "-" ),
      sorter: {
        compare: (a, b) => a.extra_shifts - b.extra_shifts,
        multiple: 1,
      },
    },
    {
      title:  ()=> <div>
        Special Hours Shift &nbsp;
        <Tooltip
          title="Sum of slots made available through single shift creation as special-hours shift"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'special_hours_shifts',
      render: (value) => ( <Text>{value.toFixed(2)}</Text> || "-" ),
      sorter: {
        compare: (a, b) => a.special_hours_shifts - b.special_hours_shifts,
        multiple: 1,
      },
    },
    {
      title:  ()=> <div>
        Active Slots &nbsp;
        <Tooltip
            title="Sum of Sum of slots (shifts) started by rider, including bulk and single shifts"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'active_slots',
      render: (value) => ( <Text>{value.toFixed(2)}</Text> || "-" ),
      sorter: {
        compare: (a, b) => a.active_slots - b.active_slots,
        multiple: 1,
      },
    },
    {
      title:  ()=> <div>
        Fill Rate &nbsp;
        <Tooltip
            title="Formula: (Scheduled/Planned) x 100"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'fill_rate',
      render: (value) => ( <Text type={value > 85 ? "" : "danger"}>{value.toFixed(2)}%</Text> || "-" ),
      sorter: {
        compare: (a, b) => a.fill_rate - b.fill_rate,
        multiple: 1,
      },
      
    },
    {
      title:  ()=> <div>
        Active vs Scheduled Rate &nbsp;
        <Tooltip
            title="Formula: (Active/Scheduled) x 100"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'active_vs_scheduled_rate',
      render: (value) => ( <Text>{value.toFixed(2)}%</Text> || "-" ),
      sorter: {
        compare: (a, b) => a.active_vs_scheduled_rate - b.active_vs_scheduled_rate,
        multiple: 1,
      },
    },
    {
      title:  ()=> <div>
        Active vs Planned Rate &nbsp;
        <Tooltip
            title="Formula: (Active/Planned) x 100"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'active_vs_planned_rate',
      render: (value) => ( <Text>{value.toFixed(2)}%</Text> || "-" ),
      sorter: {
        compare: (a, b) => a.active_vs_planned_rate - b.active_vs_planned_rate,
        multiple: 1,
      },
    },
  ]

  return (
    <div className="page-content">
        <div className="page-content-header">
            <Title level={2}>{pageName}</Title>
        </div>
        <ShiftsLevelFilter />
        <div className="p-content">
          {props?.pageLoading ? <Pageloader /> : props?.pageData?.length !== 0 ? 
            <Collapse>
              {props?.pageData && props?.pageData.map((item, i) => {
                  return (
                    <Panel header={item?.zone} key={i}>
                      <Table dataSource={item.shifts} columns={columns} pagination={false}/>
                    </Panel>
                  );
                })}
            </Collapse> :
            <div className="ant-empty"><div className="ant-empty-image"></div><div className="ant-empty-description">No Data</div></div>
          }
        </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    pageData: state.DashboardReducer.shiftDashboardData,
    pageLoading: state.DashboardReducer.shiftDashboardLoader,
    pagePagination: state.DashboardReducer.shiftDashboardPaginationData,
    pageFilter: state.DashboardReducer.shiftDashboardFilter,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    actionPage: bindActionCreators(actionPage, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShiftsLevel);